export default "__VITE_ASSET__$g9XeMLK__"